import { getDatabase, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
export default function useUpgradeRequests(state) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [upgradeRequests, setUpgradeRequests] = useState([]);
  useEffect(() => {
    async function fetchUsers() {
      //databse related works
      const db = getDatabase();
      const upgradeRef = ref(db, "UpgradeRequest");
      const upgradeQuery = query(upgradeRef);
      try {
        setError(false);
        setLoading(true);
        //request firebase database;
        onValue(upgradeQuery, (snapshot) => {
          setLoading(false);
          if (snapshot.exists()) {
            setUpgradeRequests((prevCashout) => {
              return [...Object.values(snapshot.val())];
            });
          }
        });
      } catch (err) {
        setLoading(false);
        setError(true);
      }
    }
    fetchUsers();
  }, [state]);

  return { loading, error, upgradeRequests };
}
